import Main from './main';
import { map } from '../map/map.desktop';

export default class MainDesktop extends Main {
    constructor() {
        super();

        this._device = 'desktop';
        this._map = map;

        this._initContext();
    } 
}

const __dcl = () => {
    new MainDesktop();
};

document.addEventListener('DOMContentLoaded', __dcl);



// WEBPACK FOOTER //
// ./src/js/main/main.desktop.js